export default __webpack_public_path__ + "static/media/pic2.a43b8919.svg";